module.exports = __webpack_public_path__ + "img/bsyd-app.8bf3e14f.png";